import React, { useState, useRef, useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../Components/SideBar_4/cropImage";
import defaultupload from "../../assets/default-upload.svg";
import defaultupload_fb from "../../assets/default-fb.png";
import { constant } from "../API/Constant";
import { resizeImage } from "../API/ResizeUploadImg";

const ImageUploadCrop = ({
  imgType,
  aspect,
  recommendedSize,
  label,
  croppedImage,
  setCroppedImage,
  isSetImageChange,
}) => {
  const [show, setShow] = useState(false);
  const [prevImg, setPrevImg] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const inputRef = useRef(null);

  // Function to trigger file selection popup
  const triggerFileSelectPopup = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  // Function to handle image selection and resize if necessary
  const handleSetCropperImg = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const resizedImage = resizeImage(
          img,
          constant.max_img_width,
          constant.max_img_height,
        );
        setShow(true);
        setPrevImg(resizedImage);
      };
    };
  };

  // Crop complete handler
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Function to show cropped image
  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImg = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation,
      );
      isSetImageChange(true);
      setCroppedImage(croppedImg);
      setShow(false);
    } catch (e) {
      console.error(e);
    }
  }, [prevImg, croppedAreaPixels, rotation, setCroppedImage]);

  console.log("croppedImage", croppedImage);
  return (
    <div className="image-upload-crop">
      <p
        className={
          imgType === "logo_img" ? "uploadtextmain_logo" : "uploadtextmain"
        }
      >
        Upload {label} Image &nbsp;
        {imgType === "logo_img" ? (
          <span className="star-required">*</span>
        ) : (
          <span style={{ fontSize: 13, fontStyle: "italic" }}>
            &#40;Optional&#41;
          </span>
        )}
        &nbsp;&nbsp;
        {imgType === "logo_img" && <br />}
        <span className="info_text">(Recommended size {recommendedSize})</span>
        <br />
        {imgType !== "logo_img" && (
          <div style={{ paddingRight: 10 }}>
            <p className="span-italic-grey1">
              &#40;This image is ideal for social share, if you are unable to
              provide this size we will use the square image modified to fit the
              standard image recommendation.&#41;
            </p>
          </div>
        )}
      </p>

      <div
        className={
          imgType === "logo_img"
            ? "upload-area_logo cursor-pointer"
            : "upload-area_fb cursor-pointer"
        }
        onClick={triggerFileSelectPopup}
      >
        <input
          type="file"
          accept="image/*"
          ref={inputRef}
          style={{ display: "none" }}
          onChange={handleSetCropperImg}
          onClick={(e) => (e.target.value = null)}
        />
        {croppedImage ? (
          <img src={croppedImage} alt="Cropped" className="BannerImgStore" />
        ) : (
          <div
            className={
              imgType === "logo_img"
                ? "upload_banner_empty_logo"
                : "upload_banner_empty_fb"
            }
          >
            <img
              loading="lazy"
              src={imgType === "logo_img" ? defaultupload : defaultupload_fb}
              height="300"
              width="300"
              alt="upload"
            />
          </div>
        )}
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body style={{ height: 350 }}>
          <Cropper
            image={prevImg}
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={aspect}
            showGrid={false}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </Modal.Body>
        <Modal.Footer className="cropperImage">
          <Button variant="secondary" onClick={() => setShow(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={showCroppedImage}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImageUploadCrop;
